/**
 * Shared in-memory cache for GET /reviews so multiple components (and React
 * StrictMode remounts) do not duplicate the same request on startup.
 */
import { fetchReviews } from './reviews';
import { type Review } from './types';

let cachedItems: Review[] | null = null;
let inflight: Promise<Review[]> | null = null;

/** Return all reviews, reusing cache or an in-flight request when possible. */
export const loadAllReviews = async (force = false): Promise<Review[]> => {
  if (!force && cachedItems !== null) {
    return cachedItems;
  }
  if (!force && inflight !== null) {
    return inflight;
  }

  inflight = fetchReviews('all')
    .then((page) => {
      cachedItems = page.items;
      return cachedItems;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
};

/** Drop cache so the next load hits the network (e.g. after submit). */
export const invalidateReviewsCache = (): void => {
  cachedItems = null;
  inflight = null;
};
